exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.input-width[data-v-9fcc79ca] {\n\twidth: 70%;\n}\n.dialog-footer[data-v-9fcc79ca] {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-pack: center;\n\t    -ms-flex-pack: center;\n\t        justify-content: center;\n\t-webkit-box-align: center;\n\t    -ms-flex-align: center;\n\t        align-items: center;\n}\n.tree-container[data-v-9fcc79ca] {\n\tborder: 1px solid #EBEEF5;\n\tpadding: 20px 10px;\n\tmin-height: 400px;\n\toverflow-y: scroll;\n}\n", ""]);

// exports
